import { render, staticRenderFns } from "./mapGuidePage.vue?vue&type=template&id=4b28b381&scoped=true"
import script from "./mapGuidePage.vue?vue&type=script&lang=js"
export * from "./mapGuidePage.vue?vue&type=script&lang=js"
import style0 from "./mapGuidePage.vue?vue&type=style&index=0&id=4b28b381&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b28b381",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b28b381')) {
      api.createRecord('4b28b381', component.options)
    } else {
      api.reload('4b28b381', component.options)
    }
    module.hot.accept("./mapGuidePage.vue?vue&type=template&id=4b28b381&scoped=true", function () {
      api.rerender('4b28b381', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/commercialMap/components/mapGuidePage.vue"
export default component.exports